import { METRICS_ACTION } from '../actions/actionTypes';

export const defaultProperksChallenge = {
  name: '',
  count: 0,
  type: '',
  reward: 0,
  dateRange: { from: undefined, to: undefined },
  professionType: [],
  levels: [],
  states: [],
};

const defaultState = {
  badges: [],
  loyalty: [],
  properksRedeemPoints: {},
  properksChallenges: {},
  properksInitialValue: defaultProperksChallenge,
  properksUpdateAt: new Date(),
  properksFilter: {},
  properksProfessionalChallenges: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case METRICS_ACTION.FETCH_HYG_BADGES_SUCCESS: {
      return {
        ...state,
        badges: action.payload,
      };
    }

    case METRICS_ACTION.FETCH_HYG_LOYALTY_LEVEL_SUCCESS: {
      return {
        ...state,
        loyalty: action.payload ?? [],
      };
    }

    case METRICS_ACTION.GET_PROFESSIONAL_POINTS_SUCCESS: {
      return {
        ...state,
        properksRedeemPoints: action.payload,
      };
    }

    case METRICS_ACTION.GET_PROPERKS_CHALLENGE_SUCCESS: {
      return {
        ...state,
        properksChallenges: action.payload.data,
        properksFilter: action.payload.filter
      };
    }

    case METRICS_ACTION.LAUNCH_PROPERKS_CHALLENGE_SUCCESS: {
      return {
        ...state,
        properksInitialValue: defaultProperksChallenge,
        properksUpdateAt: new Date(),
      };
    }

    case METRICS_ACTION.CANCEL_PROPERKS_CHALLENGE_SUCCESS: {
      return {
        ...state,
        properksChallenges: {
          ...state.properksChallenges,
          data: (state.properksChallenges?.data || []).map((item) => {
            if (item.id === action.payload) {
              return { ...item, is_cancelled: true };
            }
            return { ...item };
          }),
        },
      };
    }
    
    case METRICS_ACTION.RELAUNCH_PROPERKS_CHALLENGE: {
      return {
        ...state,
        properksInitialValue: action.payload,
      };
    }
    
    case METRICS_ACTION.GET_PROPERKS_PROFESSIONAL_CHALLENGE_SUCCESS: {
      return {
        ...state,
        properksProfessionalChallenges: action.payload,
      };
    }

    default:
      return state;
  }
};
